import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PHOTOS, CONTACT } from "@/data/content";
import { scrollToId } from "@/components/Navbar";

export default function ClosingCTA() {
  return (
    <section data-testid="closing-cta" className="relative flex min-h-[85svh] items-end overflow-hidden bg-[#F7F1E6] text-[#6B5D4F]">
      <motion.img
        src={PHOTOS.holdingBook}
        alt="Susan Grau holding Infinite Life, Infinite Lessons"
        initial={{ scale: 1.1 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 2, ease: [0.76, 0, 0.24, 1] }}
        className="absolute inset-0 h-full w-full object-cover object-top opacity-55"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#F7F1E6] via-[#F7F1E6]/55 to-[#F7F1E6]/15" aria-hidden="true" />

      <div className="relative z-10 w-full px-6 py-20 lg:px-16">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-body text-[0.65rem] font-medium uppercase tracking-[0.5em] text-[#C5A059]"
        >
          The House of Infinite Life · Bookings
        </motion.p>

        <motion.h2
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={{ show: { transition: { staggerChildren: 0.12 } } }}
          className="mt-6 font-display2 uppercase leading-[0.85] tracking-[0.01em] text-[13vw] md:text-[9vw]"
        >
          <span className="block overflow-hidden">
            <motion.span
              className="block"
              variants={{ hidden: { y: "110%" }, show: { y: "0%" } }}
              transition={{ duration: 1.1, ease: [0.76, 0, 0.24, 1] }}
            >
              Book Susan
            </motion.span>
          </span>
          <span className="block overflow-hidden">
            <motion.span
              className="block"
              variants={{ hidden: { y: "110%" }, show: { y: "0%" } }}
              transition={{ duration: 1.1, ease: [0.76, 0, 0.24, 1] }}
            >
              <span className="font-display normal-case italic tracking-normal text-[#C5A059]">before the season fills.</span>
            </motion.span>
          </span>
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.25 }}
          className="mt-12 flex flex-wrap items-end justify-between gap-8"
        >
          <p className="max-w-md font-display text-xl font-light leading-snug text-[#6B5D4F]/85 md:text-2xl">
            Television, keynotes, podcasts, and print — the conversation your audience
            will still be carrying next week.
          </p>
          <button
            data-testid="closing-book-btn"
            onClick={() => scrollToId("#press")}
            className="group flex items-center gap-3 bg-[#6B5D4F] px-9 py-4 font-body text-[0.7rem] font-medium uppercase tracking-[0.3em] text-[#F7F1E6] transition-colors duration-500 hover:bg-[#C5A059] hover:text-[#6B5D4F]"
          >
            Start a booking
            <ArrowUpRight size={16} className="transition-transform duration-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </button>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.35 }}
          className="mt-10 font-body text-[0.6rem] font-medium uppercase tracking-[0.3em] text-[#6B5D4F]/55"
        >
          {CONTACT.name} · M Media Corp · {CONTACT.phone} · {CONTACT.email}
        </motion.p>
      </div>
    </section>
  );
}
